import React from 'react'
import MovieCard from './MovieCard'

const MovieList = ({title, Movies}) => {
    // console.log(Movies)
  return (
    <div className='p-6 pb-8'>
         <h1 className='text-lg md:text-2xl font-bold text-white' >{title}</h1>
        <div className='flex overflow-x-scroll py-5'>
          <div className='flex gap-3'>
               {Movies?.map((data)=> <MovieCard key={data?.id} posterPath={data?.poster_path} Movie_ID_fecth ={data?.id}/>)}
          </div>
        </div>
    </div>
  )
}

export default MovieList;